export default {
    can_recall: false, // 用户召回活动是否可以参加
    system_error_data: {
        show_dialog: false,
        title: null, // 公告标题
        content: null, // 公告内容
        residue: 0, // 剩余催促次数
        times: 0 // 已有多少人催促
    }, // 是否显示系统错误弹框
    sessionId: null, // 用户的sessionId
    vip_home_dialog_index: 0, // 会员弹框顺序
    story_activity: {
        showBubble: false, //是否可以参加故事会
        startTime: null, // 故事会开始时间
        endTime: null // 故事会结束时间
    },
    user_info: null, // 用户信息
    sso_sessionid: null, // 用户sso_sessionid
    appName: null, // 用户appName
    vinVno: '' // 上传车架号车牌号
}
